import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";

type CurrentValue = {
  display: string;
  icon: string;
  value: string;
};

@Component({
  selector: "snt-button-toggle",
  templateUrl: "button-toggle.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ButtonToggleComponent implements OnChanges {
  @Input()
  value: string | undefined;

  @Input()
  values: Array<{ display: string; value: string; icon: string }> = [];

  @Output()
  valueChanged: EventEmitter<{
    buttonClickAsyncEvent: ButtonClickAsyncEvent;
    value: string;
  }> = new EventEmitter();

  current: CurrentValue | undefined;

  currentIndex = 0;

  ngOnChanges(changes: SimpleChanges): void {
    const valueChange = changes.value;

    if (valueChange) {
      const itemFound = this.values.find(
        (x) => x.value === valueChange.currentValue
      );

      if (itemFound) {
        this.current = {
          display: itemFound.display,
          icon: itemFound.icon,
          value: itemFound.value
        };
      } else {
        this.current = undefined;
      }
    }
  }

  onToggle(buttonClickAsyncEvent: ButtonClickAsyncEvent): void {
    if (this.currentIndex === this.values.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }

    this.current = this.values[this.currentIndex];

    this.valueChanged.emit({
      buttonClickAsyncEvent,
      value: this.current.value
    });
  }
}
